import { FC, useEffect, useState } from 'react';

import dashboardFiltersButtonClick from '@hh.ru/analytics-js-events/build/clickme/employer/common/dashboard_filters_button_click';
import { useBreakpoint } from '@hh.ru/magritte-ui';

import Button, { ButtonIconPosition } from 'bloko/blocks/button';
import Click from 'bloko/blocks/drop/Down/Click';
import NoPaddings from 'bloko/blocks/drop/Down/NoPaddings';
import DropInfo, { InfoPlacement, InfoTheme } from 'bloko/blocks/drop/Info';
import HSpacing from 'bloko/blocks/hSpacing';
import Icon, { IconScale, IconView } from 'bloko/blocks/icon';
import Text from 'bloko/blocks/text';
import { Placement } from 'bloko/common/metrics';
import LocalStorageWrapper from 'bloko/common/storage/LocalStorageWrapper';

import useTrls from 'hooks/translation/useTrls';

import withErrorBoundary from 'components/common/ErrorBoundary/withErrorBoundary';
import { fetchFiltersList } from 'components/Dashboard/Filters/fetchFiltersList';
import FiltersDropContent from 'components/Dashboard/Filters/FiltersDropContent/FiltersDropContent';

import { useDispatch, useSelector } from 'store/utils';

import styles from 'components/Dashboard/Filters/Filters.module.less';

const TrlKeys = {
    button: 'Dashboard.Filters.button',
    dropTip: 'Dashboard.Filters.dropTip',
};

export const IS_CAMPAIGNS_FILTERS_NEW_TIP_WAS_SHOWN = 'IS_CAMPAIGNS_FILTERS_NEW_TIP_WAS_SHOWN';

const Filters: FC = () => {
    const appliedFiltersCount = useSelector((state) => state.dashboard.appliedFiltersCount);
    const isLoadingFiltersList = useSelector((state) => state.dashboard.isLoadingFiltersList);

    const { isXS, isS } = useBreakpoint();
    const [isTipWasShown, setIsTipWasShown] = useState(
        Boolean(LocalStorageWrapper.getItem(IS_CAMPAIGNS_FILTERS_NEW_TIP_WAS_SHOWN))
    );

    const trl = useTrls();
    const dispatch = useDispatch();

    useEffect(() => {
        void dispatch(fetchFiltersList());
    }, [dispatch]);

    const onDropTipClose = () => {
        setIsTipWasShown(true);
        LocalStorageWrapper.setItem(IS_CAMPAIGNS_FILTERS_NEW_TIP_WAS_SHOWN, 'true');
    };

    const count =
        appliedFiltersCount > 0 ? (
            <>
                {!(isXS || isS) && <HSpacing base={2} />}
                <span className={styles.filterCount}>{appliedFiltersCount}</span>
            </>
        ) : undefined;

    return (
        <DropInfo
            show={!isTipWasShown}
            placement={InfoPlacement.BottomStart}
            showCloseButton
            theme={InfoTheme.Dark}
            closeByClickOutside={false}
            onClose={onDropTipClose}
            render={() => <Text>{trl(TrlKeys.dropTip)}</Text>}
        >
            <Click
                placement={Placement.BottomStart}
                render={(closeDrop) => (
                    <NoPaddings>
                        <FiltersDropContent closeDrop={closeDrop} />
                    </NoPaddings>
                )}
            >
                <Button
                    iconPosition={ButtonIconPosition.Left}
                    icon={<Icon view={IconView.Adjustments} scale={IconScale.Small} />}
                    onClick={() => dashboardFiltersButtonClick()}
                    disabled={isLoadingFiltersList}
                    data-qa="filter-button"
                >
                    {!(isXS || isS) ? (
                        <>
                            {trl(TrlKeys.button)} {count}
                        </>
                    ) : (
                        count
                    )}
                </Button>
            </Click>
        </DropInfo>
    );
};

export default withErrorBoundary(Filters);
